module.exports = __webpack_public_path__ + "a53c32e5ba6235432f85fe046c795658.jpg";